import { GetterTree } from 'vuex';
import { State } from './state';

import { RootState } from '@/store';
import { AuthUser, LoginConfig } from '@/models/AuthModels';
import { LogLevel, Configuration } from '@azure/msal-browser';
import { KeycloakConfig } from 'keycloak-js';
import { ApiKey, CreateApiKeyResponse } from '@/models/ApiKeyModels';

export type Getters = {
  authUser(state: State): AuthUser | null;
  loggedIn(state: State): boolean;
  loginConfig(state: State): LoginConfig | null;

  getAzureMsalConfig(state: State): Configuration | null;
  getKeycloakConfig(state: State): KeycloakConfig | null;

  apiKeys(state: State): Array<ApiKey>;
  createdApiKey(state: State): CreateApiKeyResponse | null;
};

export const getters: GetterTree<State, RootState> & Getters = {
  authUser(state: State) {
    return state.authUser;
  },

  loggedIn(state: State) {
    return state.loggedIn;
  },

  loginConfig(state: State) {
    return state.loginConfig;
  },

  getAzureMsalConfig(state: State) {
    if (state.loginConfig == null) {
      return null;
    }

    const msalConfig: Configuration = {
      auth: {
        clientId: state.loginConfig.azureClientId,
        authority: state.loginConfig.azureAuthority,
        redirectUri: window.location.origin + '/login',
      },
      cache: {
        cacheLocation: 'localStorage',
      },
      system: {
        // loggerOptions: {
        //   loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        //     if (containsPii) {
        //       return;
        //     }
        //     switch (level) {
        //       case LogLevel.Error:
        //         console.error(message);
        //         return;
        //       case LogLevel.Info:
        //         console.info(message);
        //         return;
        //       case LogLevel.Verbose:
        //         console.debug(message);
        //         return;
        //       case LogLevel.Warning:
        //         console.warn(message);
        //         return;
        //       default:
        //         return;
        //     }
        //   },
        //   logLevel: LogLevel.Verbose,
        // },
      },
    };

    return msalConfig;
  },

  getKeycloakConfig(state: State) {
    if (state.loginConfig == null) {
      return null;
    }

    // Keycloak Authority Format: https://keycloak-server/auth
    // Wir extrahieren die URL ohne /auth
    let keycloakUrl = state.loginConfig.keycloakAuthority;

    // Entferne /auth oder /realms/{realm} falls vorhanden
    keycloakUrl = keycloakUrl.replace(/\/auth\/?$/, '');
    keycloakUrl = keycloakUrl.replace(/\/realms\/.*$/, '');

    const keycloakConfig: KeycloakConfig = {
      url: keycloakUrl,
      realm: state.loginConfig.keycloakRealm,
      clientId: state.loginConfig.keycloakClientId,
    };

    return keycloakConfig;
  },

  apiKeys(state: State) {
    return state.apiKeys;
  },

  createdApiKey(state: State) {
    return state.createdApiKey;
  },
};
